import type { ReactNode } from 'react';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Key design „Prázdny stav“: centred H3, Body #4a5560 and the way on (text buttons, chips). Lists
 * that change on the client render it inside their `aria-live` region.
 */
export function EmptyState({
  title,
  text,
  headingAs = 'h2',
  children,
  className,
}: {
  title: string;
  text?: string;
  /** Semantic level; the style is H3 either way. */
  headingAs?: 'h2' | 'h3';
  /** Text buttons or links under the text. */
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center gap-3 text-center md:gap-4', className)}>
      <Heading tag="h3" as={headingAs} align="center" title={title} />
      {text ? <p className="svt-body w-full text-[#4a5560] md:max-w-[652px]">{text}</p> : null}
      {children ? (
        <div className="flex w-full flex-col items-center gap-4 pt-2">{children}</div>
      ) : null}
    </div>
  );
}
